import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { User } from 'views/App/Portal/LexID/Users/_types/user';

export const getUser = async (organizationId: string, id: string, onError?: (errors: ServerErrorResponse) => void) => {
  try {
    const data = await fetcher({
      method: 'get',
      url: `${baseApiUrl()}/lexid/admin-user/v1/organizations/${organizationId}/users/${id}`,
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useOrganizationUser(
  organizationId: string,
  id: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-user/v1/organizations/${organizationId}/users/${id}`;
  return useQuery<User, ServerErrorResponse>(
    ['organization_user', organizationId, id],
    async () => {
      if (organizationId && id) {
        const data = await fetcher({
          method: 'get',
          url,
        });
        return data;
      }
    },
    {
      keepPreviousData: false,
      ...options,
    }
  );
}
